
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "29",
    "height": "30",
    "viewBox": "0 0 29 30"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "#333",
                            "d": "M13.281 23.977v1.672c-1.037-.764-2.013-2.461-2.649-4.798h1.688c-.036-.322-.06-.65-.06-.982 0-.217.016-.43.032-.643h-2.026c-.18-1.002-.302-2.09-.345-3.25h3.255c.43-.865.999-1.643 1.677-2.305v-2.57h3.942c.022.132.033.276.053.41.508-.107 1.036-.163 1.573-.169-.011-.079-.016-.163-.028-.241h3.872c.172.458.31.933.42 1.42.926.564 1.734 1.308 2.382 2.187C26.915 7.674 21.339 2 14.503 2c-6.93 0-12.57 5.832-12.57 13s5.64 13 12.57 13c.935 0 1.844-.11 2.72-.31-1.677-.755-3.065-2.067-3.942-3.713zM23.497 9.475h-3.416c-.413-1.803-1.02-3.358-1.775-4.558 2.182.883 4.005 2.5 5.191 4.558zm-8.644-5.29c.22.008.441.014.659.035 1.164.71 2.28 2.583 2.954 5.256h-3.613v-5.29zM13.28 14.352H9.914c.029-1.156.133-2.244.298-3.25h3.07v3.25zm0-9.999v5.123h-2.739c.632-2.508 1.654-4.322 2.74-5.123zm-2.58.565c-.753 1.2-1.362 2.755-1.774 4.558H5.51C6.696 7.416 8.519 5.8 10.702 4.917zM4.742 11.1h3.873c-.156 1.028-.245 2.119-.271 3.25H4.06c.066-1.14.3-2.232.682-3.25zm.117 8.125c-.416-1.014-.682-2.107-.782-3.25H8.35c.04 1.135.149 2.223.32 3.25H4.857zm.843 1.624H9c.41 1.666.991 3.105 1.7 4.233-2.066-.835-3.813-2.327-5-4.233z",
                            "transform": "translate(-388 -781) translate(355 767) translate(33 14)"
                          }
                        },
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "#333",
                            "d": "M20.3 13c-2.67 0-4.833 2.247-4.833 5.018 0 1.003 2.34 5.62 3.758 8.324.458.875 1.662.878 2.124.005 1.428-2.698 3.784-7.305 3.784-8.328C25.133 15.247 22.97 13 20.3 13m-.431 7.758c-1.682-.275-2.775-2.06-2.196-3.815.368-1.116 1.418-1.91 2.554-1.931 1.786-.033 3.087 1.593 2.823 3.338-.239 1.577-1.663 2.655-3.181 2.408",
                            "transform": "translate(-388 -781) translate(355 767) translate(33 14)"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  